'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validAlignProps = exports.validDirectionProps = exports.validJustifyProps = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: content-box;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  display: flex;\n\n  ', '\n'], ['\n  box-sizing: content-box;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  display: flex;\n\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _responsiveProps = require('responsive-props');

var _responsiveProps2 = _interopRequireDefault(_responsiveProps);

var _propTypes2 = require('./propTypes');

var propTypes = _interopRequireWildcard(_propTypes2);

var _mixins = require('./utils/mixins');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // eslint-disable-line
// import getstyledFlexboxGrid from './HOC/getstyledFlexboxGrid';


var StyledRow = _styledComponents2.default.div(_templateObject, function (_ref) {
  var responsiveProps = _ref.responsiveProps;
  return responsiveProps;
});

var Row = function Row(props) {
  var children = props.children,
      styledFlexboxGrid = props.theme.styledFlexboxGrid,
      fullWidth = props.fullWidth;
  var breakpoints = styledFlexboxGrid.breakpoints,
      rowWidth = styledFlexboxGrid.rowWidth,
      getGutterWidth = styledFlexboxGrid.getGutterWidth,
      getColumnWidth = styledFlexboxGrid.getColumnWidth;
  var RowhResponsiveProps = (0, _responsiveProps2.default)(StyledRow, {
    align: _mixins.alignColumns,
    justify: _mixins.justify,
    sideMargin: _mixins.sideMargin,
    direction: _mixins.direction,
    center: _mixins.center,
    rowWidth: function rowWidth(args) {
      return (0, _mixins.rowWidth)(args, fullWidth);
    },
    debug: function debug(args) {
      return (0, _mixins.debug)(props.debug, getGutterWidth(args), getColumnWidth);
    }
  });
  return _react2.default.createElement(RowhResponsiveProps, {
    styledFlexboxGrid: styledFlexboxGrid,
    align: props.align,
    justify: props.justify,
    rowWidth: rowWidth,
    center: props.center,
    direction: props.direction,
    debug: styledFlexboxGrid.gutter,
    breakpoints: breakpoints
  }, children);
};

var validJustifyProps = exports.validJustifyProps = Object.keys(_mixins.justifyValues);
var validDirectionProps = exports.validDirectionProps = Object.keys(_mixins.directionValues);
var validAlignProps = exports.validAlignProps = Object.keys(_mixins.alignValues);
var rowPropTypes = {
  children: _propTypes.node,
  fullWidth: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.bool), _propTypes.bool]),
  center: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.bool), _propTypes.bool]),
  debug: _propTypes.bool,
  // Responsive props
  theme: (0, _propTypes.shape)({
    styledFlexboxGrid: (0, _propTypes.shape)(propTypes.styledFlexboxGrid)
  }),
  align: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(validAlignProps), (0, _propTypes.objectOf)((0, _propTypes.oneOf)(validAlignProps))]),
  justify: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(validJustifyProps), (0, _propTypes.objectOf)((0, _propTypes.oneOf)(validJustifyProps))]),
  direction: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)((0, _propTypes.oneOf)(validDirectionProps)), (0, _propTypes.oneOf)(validDirectionProps)])
};
Row.propTypes = rowPropTypes;
Row.defaultProps = {
  children: null,
  align: undefined,
  justify: undefined,
  direction: undefined,
  theme: (0, _propTypes.shape)({}),
  fullWidth: false,
  center: true,
  debug: false
};
var GridRow = (0, _styledComponents.withTheme)(Row);
GridRow.displayName = 'Row';
GridRow.propTypes = rowPropTypes;
exports.default = GridRow;